import { IMainPhoto } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';
import { IPhotoData } from './photo';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { IMAGE_ACTION_TYPE } from 'redhotpie-shared-lib/constants/constants';

interface UploadedPhotoData {
  ParentType?: string;
  LikeCount?: number;
  ReplyCount?: number;
  IsMemberLike?: boolean;
  ProfilePhotos?: IPhotoData[];
  SEOUrl?: string;
}

export default class UploadedPhoto {
  parrentType: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  profilePhotos: IMainPhoto[];
  seoURL?: string;

  constructor() {
    this.parrentType = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.profilePhotos = [];
    this.seoURL = '';
  }

  static mappingPhoto(_obj: IPhotoData): IMainPhoto {
    const obj: IMainPhoto = {
      photoID: _obj.PhotoID,
      height: _obj.Height ? _obj.Height : 0,
      width: _obj.Width ? _obj.Width : 0,
      isUserImage: _obj.IsUserImage ? _obj.IsUserImage : false,
      isPublic: _obj.IsPublic ? _obj.IsPublic : false,
      classification: _obj.Classification ? _obj.Classification : 1,
      thumbUrl: _obj.ThumbUrl ? _obj.ThumbUrl : '',
      fullUrl: _obj.FullUrl ? _obj.FullUrl : '',
      imageActionType: _obj.ImageActionType || IMAGE_ACTION_TYPE.SHOW_IMAGE,
      imageType: _obj.ImageType ? _obj.ImageType : '',
      isLiked: !!_obj.IsLiked,
      memberLikeCount: _obj.MemberLikeCount || 0,
      showSafeMode: _obj.ShowSafeMode,
    };
    return obj;
  }

  static mappingProfilePhotos(data: IPhotoData[]): IMainPhoto[] {
    return data.map(item => UploadedPhoto.mappingPhoto(item));
  }

  static mappingObject(_obj: UploadedPhotoData): IContentItem {
    let obj = Object.assign(new UploadedPhoto(), _obj);
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.likeCount = _obj.LikeCount ? _obj.LikeCount : 0;
    obj.replyCount = _obj.ReplyCount ? _obj.ReplyCount : 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.profilePhotos = _obj.ProfilePhotos ? UploadedPhoto.mappingProfilePhotos(_obj.ProfilePhotos) : [];
    obj.seoURL = _obj.SEOUrl || '';
    obj = utils.cleanObjectKeys(Object.keys(new UploadedPhoto()), obj);

    return obj;
  }

  static mappingObjects(_data: UploadedPhotoData[]): IContentItem[] {
    return _data.map(item => UploadedPhoto.mappingObject(item));
  }
}
